require("./menu-l3-balancer/menu-l3-balancer");
//// Highlisht the items on the top menu
//function highlightTopMenu() {

//    var fundItemSelector = 'a[href="' + window.location.pathname + '"].fund-link';
//    var ctaItemSelector = 'a[href="' + window.location.pathname + '"].cta-link';
//    var subMenuItemSelector = 'a[href="' + window.location.pathname + '"].site-header__submenu-action';
//    var mobileSubMenuItemSelector = 'a[href="' + window.location.pathname + '"].site-header__mobile-submenu-action';

//    var activeMenuElements = $(fundItemSelector + ', ' + ctaItemSelector + ', ' + subMenuItemSelector + ', ' + mobileSubMenuItemSelector);

//    if (activeMenuElements.length !== 0) {
//        $(activeMenuElements).each(function (i, el) {
//            var topMenuElement = $(el).closest('.site-header__nav-item.nav-item').find('a').first();

//            $(topMenuElement).addClass('active');
//        });
//    }
//}

//window.addEventListener("DOMContentLoaded", highlightTopMenu);

function updatePageVistCountOnLocalStorage() {
    var pageVisitCount = localStorage.getItem("ve-PageVisitCount");
    if (pageVisitCount) {
        pageVisitCount = parseInt(pageVisitCount) + 1;
    } else {
        //if gateway modal is open, ignore the page visit
        const gatewayModal = document.getElementById("gateway-modal");
        if(gatewayModal && gatewayModal.classList.contains("show")) return;
        pageVisitCount = 1;
    }
    var pageVisitsTracked = localStorage.getItem("ve-pagevisits-us");
    if (!pageVisitsTracked) {
        pageVisitCount = 1;
    }
    localStorage.setItem("ve-PageVisitCount", pageVisitCount);
}

window.addEventListener("DOMContentLoaded", updatePageVistCountOnLocalStorage);

function ahpScripts() {
       //Disable GPU rendering in Popper for IE11. Fixes blurryness, rending issues etc.
       Popper.default.Defaults.modifiers.computeStyle.gpuAcceleration =
       (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) ?
           false : Popper.default.Defaults.modifiers.computeStyle.gpuAcceleration;

   //Add a class to the body once the Gateway modal is opened.. this is to make sure the gateway is above everything...
   $("#gateway-modal").on('show.bs.modal', function() {$('body').addClass("gateway-modal-open")}).on('hide.bs.modal', function() {$('body').removeClass("gateway-modal-open")})

   //hide the gateway if the "focus-on-content" class is added to the body. In this mode we do not show the Gateway at all.
   $("body").hasClass("focus-on-content") && $("#gateway-modal").modal("hide"); 
}

window.addEventListener("DOMContentLoaded", ahpScripts);

function menuScripts() {

    //Convert the megamenu tabs in the investments section to work as tab on hover.
    hoverfytabs('.navbar .investments-tabs > .nav-tabs > li', false);
    //hoverfytabs('.bs4-nav .site-header__submenu-inner .list-group', false);

}

document.addEventListener("dynamicMenuLoaded", menuScripts);


/*** These are a duplicate of static/js/header/header-override.js
 *      Make sure they are modified there too! ***/

/*** converts a bs4 tab-nav to render on hover vs click ***/
hoverfytabs = function (selector, hoverblock) {
    hoverblock = (!hoverblock) ? false : hoverblock;

    //hover changed to click - (Requirement on WEBUS-26)
    $(selector).click(function () {
        if ($(this).hasClass('hoverblock'))
            return;
        else
            /*force remove everything else*/
            targettedTabGroup = $(this).parent().find('a.active').data('target')
        $(targettedTabGroup).parent().find('.active.show').removeClass('active').removeClass('show')
        $(this).parent().find('a').removeClass('active').removeClass('show')
        $(this).find('a').tab('show');
    });
    if (hoverblock === true) {
        $(selector).find('a').click(function () {
            $(this).parent()
                .siblings().addClass('hoverblock');
        });

    }

}



/***
 * Sticky-secondary nav code
 */
window.stickywaypoint = {
    sticky: function () {
        return $('#sticky-waypoint').hasClass("sticky");
    },
    detachWaypoint: function () {
        //Remove all Vshift code
        var elem = document.getElementById('sticky-waypoint');
        elem.parentNode.replaceChild(elem.cloneNode(true), elem);
    },
    checkIntersection: function () {
        var head = $(".site-header")[0].getBoundingClientRect().bottom;
        var hero = $(".hero__content-container").length > 0 ? $(".hero__content-container")[0].getBoundingClientRect().bottom : 0;
        return head - hero;
    },
    toggle: function (makeSticky) {
        if (makeSticky) { $('#sticky-waypoint').addClass('sticky'); return; }
        $('#sticky-waypoint.sticky').removeClass('sticky');
    },
    doScroll: function () {
        if ((stickywaypoint.checkIntersection() > -20) && !stickywaypoint.sticky()) { stickywaypoint.toggle(true); return; }
        if ((stickywaypoint.checkIntersection() < -19) && stickywaypoint.sticky()) { stickywaypoint.toggle(false); return; }
    },
    init: function () {
        $('#sticky-waypoint').addClass('loaded');
        stickywaypoint.detachWaypoint();
        $(window).scroll(stickywaypoint.doScroll);
    }
}

window.addEventListener("load", function () {
    //Guard: only run these scripts if the page contains a scrollspy.
    if ($("#sticky-waypoint.secondary-nav").length < 1) return;

    //Initialise the above.
    stickywaypoint.init();

    //Remove it as soon as page loads only if its not a insights page.
    if ($(".page-class-insights #sticky-waypoint").length == 0) {
        window.setTimeout(function () { $('#sticky-waypoint').removeClass('sticky'); }, 100);
    }
});


/*
 * Sticky back-to-top
 */
window.stickyBackToTop = {
    init: function () {

        if ($('#back-to-top-wrapper > .back-to-top').length === 0) return;

        var $btt = $('#back-to-top-wrapper > .back-to-top');
        var $win = $(window);
        var height = $win.height() / 4;

        $win.scroll(function (e) {
            $win.scrollTop() > height ? $btt.show() : $btt.hide();
        });

    }
}
window.addEventListener('DOMContentLoaded', function () {
    stickyBackToTop.init();
});



window.addEventListener('DOMContentLoaded', function () {
    /*
* Sticky head - remove shadow and add back when scrolled
*/
    
    function removeShadow() {
      $(".site-header").addClass("no-drop-shadow");
    }

    function addShadow() {
      $(".site-header").removeClass("no-drop-shadow");
    }

    setTimeout(() => {
        checkScroll();
    }, 100);

    $(window).scroll(function () {
        checkScroll();
    });

    function checkScroll() {
      var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            addShadow();
        } else {
            removeShadow();
        }
    }

    /**
 * Mega-menu event handler to prevent being overridden by a dropdown.
 */
    $("li.site-header__nav-item.nav-item").hover(function () {
        $(".dropdown-menu.show").removeClass("show");
        $(".dropdown.show, .dropdown-checkbox.show").removeClass("show")
    });
});

/* Touchend to prevent the double touch required on iPad */
$('.touchend-trigger-click').on('click touchend', function (e) {
    var el = this;
    var link = el.tagName == 'A' ? $(el).attr('href') : $(el).find('a:first').attr('href');
    window.location = link;
});

window.addEventListener('DOMContentLoaded', function () {
    //add the relevant spacing for the blocks with the IDs
    window.GenerateAnchoredBlocks = (isBlog) => {
        var siteHeaderHeight = $(".mobile-push .site-header").height() + 75 ?? $(".site-header").height() + 50;
        $('.anchored-block').each(function (id) {
            if (isBlog) {
                $(this).removeAttr("style");
            }
/*            let marginTop = parseInt($(this).css("margin-top"));
            let paddingTop = parseInt($(this).css("padding-top"));
            let newPaddingTop = siteHeaderHeight + paddingTop;
            let newMarginTop = marginTop - siteHeaderHeight;
            let newInlineStyles = ';padding-top:' + newPaddingTop + 'px !important; margin-top: ' + newMarginTop + 'px !important';
            let style = $(this).attr('style');
            style += newInlineStyles;
            //console.log(style);
            $(this).attr('style', style);
            //$(window).scrollTop(y + 150);*/
            $(this).css("scroll-margin-top", siteHeaderHeight);
        })
        $('[data-spy="scroll"]').each(function () {
            $(this).scrollspy('refresh')
        })
    }
    if ($('.anchored-block')) GenerateAnchoredBlocks(false);
    
});


//Smooth scroll on Back to Top button click
$("#back-to-top-wrapper").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000, function () {
        if (window.innerWidth < 1024) {
            window.scrollBy(0, 10);
        }
    });
});

//handle the signin popup in the menu for US
window.addEventListener('DOMContentLoaded', function () {

    handleSignInModal = {
        mobileModal: $('#signin-panel-mobile'),
        desktopModal: $("#signin-panel"),

        init: function() {
            handleSignInModal.manipulateMobilePopupContent();
            handleSignInModal.moveMobileModalToBody()
            handleSignInModal.closeModals()
            handleSignInModal.removeColClassInHomePage()
            handleSignInModal.removeAdditionalSpinnersInModal()
            handleSignInModal.addRequiredAsterisk()
            handleSignInModal.handleModalSpinners()
            handleSignInModal.closeSignInModalInMenuClick()
            handleSignInModal.signinPanelRightPosition()
        },

        manipulateMobilePopupContent: function () {
            if ($('#navbar-nav').is(":visible") || $(".tab-subscribe-btn").is(":visible")) {
                handleSignInModal.mobileModal.remove();
            }
            else {
                handleSignInModal.desktopModal.remove();
                if (handleSignInModal.mobileModal !== null && $("#signin-panel-mobile").length == 0) {
                    $(".nav-item.signin-link").not(".site-header__nav-item").after(handleSignInModal.mobileModal)
                }
            }
        },

        moveMobileModalToBody: function () {
            if ($('#site-header-mobile-menu #signin-panel-mobile').length > 0) {
                var mobileSigninModal = $("#site-header-mobile-menu #signin-panel-mobile")
                $("#site-header-mobile-menu #signin-panel-mobile").remove()
                $("body").append(mobileSigninModal)
            }
        },

        closeModals: function () {
            $("#desktopSigninModalClose, .site-header__mobile-menu-toggle, .mobile-search-ico,.gateway").on("click", function (e) {
                $("#desktopSigninModalClose").parent().removeClass("collapse").addClass("collapsing").removeClass("show collapsing").addClass("collapse");
            })
            $("#mobileSigninModalClose").on("click", function () {
                $('#signin-panel-mobile').modal('hide');
            })
        },

        removeColClassInHomePage: function () {
            $(".home-page .subscribe-block__form-content-wrp").removeClass("col-lg-12");
        },

        removeAdditionalSpinnersInModal: function () {
            if ($(".funds.fund-listing, .react-portfolio-page").length == 0) return
            setTimeout(() => {
                var spinners = $("#signin-panel #veSpinnerContainer #loading");
                if (spinners.length > 1) {
                    spinners[0].remove()
                }
            },3000)
        },
        addRequiredAsterisk: function () {
            var $emailContainer = $(".menu-signin-subscription-access-block .subscribe-block__form-content-wrp .FormTextbox")
            $emailContainer.find("label>.RequiredAsterisk").remove()
            //if ($emailContainer.hasClass("ValidationRequired")) {
                //$emailContainer.find("label").append("<span class='RequiredAsterisk'>*</span>")
            //}
        },
        handleModalSpinners: function () {
            if (($(".preference-center-subscriptions").length > 0 || $(".subscription-center-page.react-subscription-page").length > 0 || $(".manage-subscription .unsubscribe-survey").length > 0) && $(".menu-signin-subscription-access-block").length > 0) {
                $(".menu-signin-subscription-access-block").prepend('<div class="veSpinnerContainer"><div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div></div>');
                if ($("#signin-panel-mobile").length > 0) {
                    $("#signin-panel-mobile .FormSubmitButton").on("click", function () {
                        doSpinner("signin-panel-mobile", "submit")
                    })
                }
                else {
                    $(".menu-signin-subscription-access-block .FormSubmitButton").on("click", function () {
                        setTimeout(() => {
                            $("#viewport-wide-spinner").hide();
                        }, 50)
                    })
                }
            }
        },
        closeSignInModalInMenuClick: function () {
            $("#tabSubscriptionBtn").on("click", function () {
                if ($("#site-header-mobile-menu:visible").length > 0) {
                    $(".site-header__mobile-menu-toggle").trigger("click");
                }
            })
        },
        signinPanelRightPosition: function () {
            if ($("#signin-panel").length == 0) return;
            var windowWidth = window.innerWidth;
            var containerWidth = $(".container").innerWidth()
            var rightAlignment = (windowWidth - containerWidth) / 2;
            $(".site-header__signin-panel").css({ right: rightAlignment })
        }

    }
    handleSignInModal.init();
    $(window).on("resize", function () {
        handleSignInModal.init();
    })
})

//to remove the display of double spinners during form submission in fund explorer page
document.addEventListener('episerverFormEvent', function (e) {
    if ($(".funds.fund-listing").length == 0) return
    if (e.detail.type == "formsStartSubmitting") {
        $("#viewport-wide-spinner").hide();
    }
})